// native
import { NgModule } from '@angular/core';

// module
import { SharedModule } from '../shared/shared.module';
import { DevicesModule } from '../devices/devices.module';

// components
import { HomeManagementWizardComponent } from './home-management-wizard/home-management-wizard.component';
import { PatientStepComponent } from './steps/patient-step/patient-step.component';
import { DeviceStepComponent } from './steps/device-step/device-step.component';
import { NetworkStepComponent } from './steps/network-step/network-step.component';
import { ReviewStepComponent } from './steps/review-step/review-step.component';
import { CodeStepComponent } from './steps/code-step/code-step.component';

@NgModule({
  imports: [
    SharedModule,
    DevicesModule
  ],
  declarations: [
    HomeManagementWizardComponent,
    PatientStepComponent,
    DeviceStepComponent,
    NetworkStepComponent,
    ReviewStepComponent,
    CodeStepComponent
  ]
})
export class HomeManagementModule { }
